export const ReportFormat = [
    { "name": "Standard with two decimal places", "value": "#,##0.00" },
    { "name": "No decimal places", "value": "#,##0" },
    { "name": "European format with comma as decimal separator", "value": "#.##0,00" },
    { "name": "European format, no decimals", "value": "#.##0" },
    { "name": "Simple decimal format", "value": "0.00" },
    { "name": "Simple European format with comma for decimals", "value": "0,00" },
    { "name": "Thousands separator with optional decimal places", "value": "#,###.##" },
    { "name": "Space as thousands separator, comma for decimal", "value": "# ###,##" },
    { "name": "Three decimal places", "value": "#,##0.000" },
    { "name": "Four decimal places", "value": "#,##0.0000" }
]
